<template>
  <div ref="budgetChangeApply_content" class="budgetChangeApply-box">
    <div
      class="budgetChangeApply-headers"
      :class="'headers-background-'+budgetChangeApplyInfo.applyStatus"
    >
      <headers
        :headInfo="{headUrl: budgetChangeApplyInfo.dingDingPhotoPath, dingdingUserId:budgetChangeApplyInfo.currentApplyDingDingId, userName: budgetChangeApplyInfo.currentApplyEmployeeName, approver: budgetChangeApplyInfo.nextApprover, approvalState: budgetChangeApplyInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="budgetChangeApply_tab" class="budgetChangeApply-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="budgetChangeApply-info d_jump">
        <div v-if="budgetChangeApplyInfo.projectInfo" class="budgetChangeApply-info-content">
          <div class="budgetChangeApply-info-box">
            <div class="budgetChangeApply-info-label">项目名称</div>
            <div
              class="budgetChangeApply-info-value"
            >{{budgetChangeApplyInfo.projectInfo.projectName}}</div>
          </div>
          <div class="budgetChangeApply-info-box">
            <div class="budgetChangeApply-info-label">项目编号</div>
            <div
              class="budgetChangeApply-info-value"
            >{{budgetChangeApplyInfo.projectInfo.projectCode}}</div>
          </div>
          <div class="budgetChangeApply-info-box">
            <div class="budgetChangeApply-info-label">合作金额</div>
            <div
              class="budgetChangeApply-info-value"
            >{{budgetChangeApplyInfo.projectInfo.proIncomeBudget|NumFormat}}元</div>
          </div>
          <div class="budgetChangeApply-info-box">
            <div class="budgetChangeApply-info-label">支出预算</div>
            <div
              class="budgetChangeApply-info-value"
            >{{budgetChangeApplyInfo.projectInfo.budgetAmount|NumFormat}}元</div>
          </div>
          <div class="budgetChangeApply-info-box">
            <div class="budgetChangeApply-info-label">支出实际</div>
            <div class="budgetChangeApply-info-value">{{sumActualExpenditure|NumFormat}}元</div>
          </div>
          <div class="budgetChangeApply-info-box">
            <div class="budgetChangeApply-info-label">项目负责人</div>
            <div class="budgetChangeApply-info-value">
              <div class="selected-box">
                <div
                  @click="openProfile(budgetChangeApplyInfo.projectInfo.pMEmployeeDingId)"
                  class="selected-item"
                >
                  <img
                    class="headimg"
                    :src="budgetChangeApplyInfo.projectInfo.pMEmployeeHead&&budgetChangeApplyInfo.projectInfo.pMEmployeeHead.length>0?budgetChangeApplyInfo.projectInfo.pMEmployeeHead:require('@/assets/images/defaultHead.png')"
                  />
                  <label>{{budgetChangeApplyInfo.projectInfo.pMEmployeeName}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目人工投入信息开始-->
        <div v-if="budgetChangeApplyInfo.budgetChangeDetails&&budgetChangeApplyInfo.budgetChangeDetails.length>0">
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">预计支出明细</div>
              <div class="purchase-order-Total">
                预算变更总额
                <span>{{budgetChangeTotal|NumFormat}}元</span>
              </div>
              <div class="ReimItem-content">
                <div class="ReimItem-box">
                  <div class="ReimItem">
                    <div class="ReimItem-vlue">预算名称</div>
                    <div class="ReimItem-label">变更前金额</div>
                    <div class="ReimItem-label">变更后金额</div>
                  </div>
                  <div
                    v-for="(detail,index) in budgetChangeApplyInfo.budgetChangeDetails"
                    :key="index"
                    class="ReimItem"
                  >
                    <div class="ReimItem-vlue">{{detail.budgetName}}</div>
                    <div class="ReimItem-label">{{detail.budgetAmount|NumFormat}}元</div>
                    <div class="ReimItem-label">{{detail.changeBudgetAmount|NumFormat}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目人工投入信息结束-->
        <!--申请原因开始-->
        <div class="divide-line"></div>
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="ReimItem-content">
              <div style="border: 0" class="ReimItem-box">
                <div style="border: 0" class="ReimItem">
                  <div
                    style="border: 0;align-items: self-end;padding: 0.13rem; "
                    class="ReimItem-label"
                  >申请原因</div>
                  <div
                    v-html="$options.filters.textareaToFormat(budgetChangeApplyInfo.applyReason)"
                    style="border: 0;justify-content:left; align-items: self-end;"
                    class="ReimItem-vlue"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--申请原因结束-->
        <div class="divide-line"></div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="budgetChangeApplyInfo.approvalList"
          :applyEmployeeID="budgetChangeApplyInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="budgetChangeApply-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:budgetChangeApplyInfo.nextApproveStep}"
        v-if="budgetChangeApplyInfo.nextApproverId&&budgetChangeApplyInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&budgetChangeApplyInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:budgetChangeApplyInfo.nextApproverUserId,applyEmployeeName:budgetChangeApplyInfo.currentApplyEmployeeName, applyTypeName:'立项申请'}"
        v-else-if="budgetChangeApplyInfo.applyEmployeeID==userInfo.employeeID&&budgetChangeApplyInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>

<script>
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
import * as dd from "dingtalk-jsapi";
export default {
  data() {
    return {
      paramInfo: {},
      budgetChangeApplyInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      dingdingconfig: state => state.dingdingconfig
    }),
    //支出实际
    sumActualExpenditure: function() {
      var sum = 0;
      if (this.budgetChangeApplyInfo.projectInfo) {
        for (
          var i =
            this.budgetChangeApplyInfo.projectInfo.passExpenditure.length - 1;
          i >= 0;
          i--
        ) {
          sum += this.budgetChangeApplyInfo.projectInfo.passExpenditure[i]
            .amount;
        }
      }
      return sum;
    },
    //变更总金额
    budgetChangeTotal: function() {
      var sum = 0;
      if (this.budgetChangeApplyInfo.budgetChangeDetails) {
        for (
          var i = this.budgetChangeApplyInfo.budgetChangeDetails.length - 1;
          i >= 0;
          i--
        ) {
          sum +=
            this.budgetChangeApplyInfo.budgetChangeDetails[i]
              .changeBudgetAmount -
            this.budgetChangeApplyInfo.budgetChangeDetails[i].budgetAmount;
        }
      }
      return sum;
    }
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getBudgetChangeApplyInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/BD/BudgetChange/GetProjectBudgetChangeApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    },
    openProfile(dingdingUserId) {
      if (dingdingUserId.length > 0) {
        let _this = this;
        dd.biz.util.open({
          name: "profile", //页面名称
          params: { id: dingdingUserId, corpId: _this.dingdingconfig.corpId }, //传参
          onSuccess: function() {
            /**/
          },
          onFail: function(err) {}
        });
      }
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum =
        _this.$refs.budgetChangeApply_content.offsetTop - 1;
      _this.$refs.budgetChangeApply_tab.style =
        "top:" + _this.tabconfig.affixNum + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.budgetChangeApplyInfo = await this.getBudgetChangeApplyInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
  },
  components: {
    headers,
    tab,
    process,
    exefoot,
    selffoot,
    passfoot
  }
};
</script>

<style lang="less" scoped>
.budgetChangeApply-box {
  .budgetChangeApply-headers {
    padding: 0 0.4rem;
  }

  .budgetChangeApply-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .budgetChangeApply-info {
      .budgetChangeApply-info-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .budgetChangeApply-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .budgetChangeApply-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .budgetChangeApply-info-value {
            margin-left: 0.2rem;
            width: 76%;
            color: #333333;
            .selected-box {
              height: auto;
              display: flex;
              flex-wrap: wrap;
              .selected-item {
                height: 0.8rem;
                margin-right: 0.4rem;
                font-size: 0.346667rem;
                img {
                  vertical-align: middle;
                }
                .headimg {
                  width: 0.533333rem;
                  height: 0.533333rem;
                  margin-right: 0.133333rem;
                  border-radius: 50%;
                }
                label {
                  vertical-align: middle;
                }
                .delete-bnt {
                  width: 0.2rem;
                  height: 0.2rem;
                }
              }
            }
          }
        }
      }
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .purchaseInfo-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order {
          .purchase-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .ReimItem-content {
            margin-top: 0.533333rem;
            .ReimItem-box {
              border-bottom: 1px solid #eee;
              font-size: 0.3467rem;
              .ReimItem {
                display: flex;
                border-left: 1px solid #eee;
                .ReimItem-label {
                  width: 2.5rem;
                  color: #333333;
                  border-top: 1px solid #eee;
                }
                .ReimItem-vlue {
                  border-top: 1px solid #eee;
                  flex: 1;
                  color: #333333;
                  padding: 0.13rem;
                }
                div {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  min-height: 1.066667rem;
                  border-right: 1px solid #eee;
                }
              }
            }
          }
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .budgetChangeApply-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/BD/Project/ProjectBudgetChange.vue